import { mdiFileDocument } from '@mdi/js'

export default []
